import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import './errorPage.css'
import error_404 from '../../assets/images/Error/error404.png'
import { Helmet } from 'react-helmet-async';

export default class ErrorPage extends Component {
    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>NAL | Error Page</title>
                </Helmet>
                <div className="container-box">
                    <div className="row error-box">
                        <div className="col-12 col-md-6 error-img">
                            <img src={error_404} alt="404 Page not found" class="img-fluid" />
                        </div>
                        <div className="col-12 col-md-6 error-text">
                            <h1>ページが見つかりません</h1>
                            <p> 
                                お探しのページが見つかりません。 <br />
                                前のページに戻るか、当社のホームページにアクセスしてください。
                            </p>
                            <Link to="/" className="btn-visit-link" >ホームページに戻る</Link>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
